import {inject} from '@angular/core';
import {CanMatchFn, Router} from '@angular/router';
import {SessionService} from '@q9elements/ui-kit/common';
import {map} from 'rxjs';

import {ROUTES_PATH} from '../models/routes-path.enum';
import {AuthenticationRoutesMatcher} from '../routing/auth.routes';
import {Q9maCookieService} from '../services/cookie.service';
import {RedirectService} from '../services/redirect.service';

export const ActiveUserGuard: CanMatchFn = route => {
  const cookieService = inject(Q9maCookieService);
  const redirectService = inject(RedirectService);
  const router = inject(Router);
  const isTokenValid = cookieService.isTokenValid();
  const sessionService = inject(SessionService);
  const newPassPathSegment = getNewPassPathSegment();
  const isAuthenticationRoute = route.matcher === AuthenticationRoutesMatcher;

  if (newPassPathSegment.includes(ROUTES_PATH.NEW_PASS) && isTokenValid) {
    cookieService.deleteToken();

    return true;
  }

  if (isTokenValid) {
    return sessionService.startSession().pipe(
      map(() => {
        const user = sessionService.user()!;

        if (user?.state !== 'active') {
          return true;
        }

        if (isAuthenticationRoute && redirectService.replayPendingRedirect()) {
          return false;
        }

        return router.createUrlTree(['t']);
      })
    );
  }

  return true;
};

function getNewPassPathSegment() {
  const segments = window.location.pathname.split('/');

  return segments[1];
}
